import React, { useState, useRef, useEffect } from 'react';
import './HomePage.css';
import axios from "axios";
import logo from '../assets/logo.jpg';
import Contact from './contactus';
import AboutUs from './aboutus';
import Milestones from './milestones';
import Gallery from './gallery';
import Leadership from './leadership';
import Events from './events';
import EventsGallery from './eventsGallery';
import kcm from '../assets/KCM.jpg';
import kmm from '../assets/KMM.jpg';
// import sampleVideo from '../assets/videos/samplevideo.mp4';
// import sampleVideo1 from '../assets/videos/samplevideo1.mp4';
// import sampleVideo2 from '../assets/videos/samplevideo2.mp4';

const baseUrl = process.env.REACT_APP_API_URL;

const districts = [
  "Thiruvananthapuram", "Kollam", "Pathanamthitta", "Alappuzha", "Kottayam", "Idukki",
  "Ernakulam", "Thrissur", "Palakkad", "Malappuram", "Kozhikode", "Wayanad", "Kannur", "Kasaragod"
];

const HomePage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    date_of_birth: '',
    address: '',
    district: '',
    place: '',
    phone: '',
    agreement: false,
  });
  const [ageError, setAgeError] = useState('');
  const [phoneError, setPhoneError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === 'checkbox' ? checked : value;

    setFormData({ ...formData, [name]: updatedValue });

    if (name === 'phone') {
      if (!/^\d{10}$/.test(value)) {
        setPhoneError('Phone number must be 10 digits');
      } else {
        setPhoneError('');
      }
    }
  };

  const handleSubmit = async () => {
    // Validate all fields except checkbox
    for (const key in formData) {
      const value = formData[key];
      if (typeof value === 'string' && !value.trim()) {
        alert(`Please fill in the ${key} field.`);
        return;
      }
    }

    // DOB validation and age calculation
    const dob = formData.date_of_birth;
    if (!dob) {
      setAgeError("Please select a date of birth.");
      return;
    }

    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age < 6 || age > 18) {
      setAgeError("Only children between 6 and 18 years are allowed to register.");
      return;
    } else {
      setAgeError('');
    }

    // Phone number validation
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      setPhoneError("Phone number must be exactly 10 digits.");
      return;
    } else {
      setPhoneError('');
    }

    // Submit form
    try {
      await axios.post(`${baseUrl}/members/join`, formData);
      setFormData({
        name: '',
        date_of_birth: '',
        address: '',
        district: '',
        place: '',
        phone: '',
        agreement: false,
      });
      setShowPopup(false);
      setShowSuccess(true);
    } catch (error) {
      console.error("Submission failed:", error);
      setShowFailure(true);
    }
  };


  return (
    <div>
      <nav className="navbar">
        <div className="nav-logo">
          <img src={logo} alt="KidZone Logo" className="logo-image" />
        </div>
        <div className="nav-header">
          <h1>AKHILA KERALA BALAJANA SAKHYAM</h1>
        </div>
        <ul className="nav-links">
          <li><a href="#home-page">Home</a></li>
          <li><a href="#milestones">Milestones</a></li>
          <li><a href="#leadership">Leadership</a></li>
          <li><a href="#events">Events</a></li>
          <li><a href="#gallery">Gallery</a></li>
          <li><a href="#contact">Contact Us</a></li>
        </ul>
      </nav>

      <div className="home-page" id="home-page">
        <div className="comic-text">
          <h2>അഖില കേരള ബാലജന സഖ്യം</h2>
          <div className="btn-container">
            <button className="btn-learn" onClick={() => document.getElementById('milestones')?.scrollIntoView({ behavior: 'smooth' })}>Learn More</button>
            <button className="btn-join" onClick={() => setShowPopup(true)}>Join Us</button>
          </div>
          <div className="torchbearers-wrapper">
            <h2 className="torchbearers-heading">മാർഗദീപം</h2>
            <div className="torchbearers-section">
              <div className="torchbearer">
                <img src={kcm} alt="K. C. Mammen Mappillai" className="small-icon" />
                <p className="torchbearer-name">K. C. Mammen Mappillai </p>
                <p className="torchbearer-name">Founder </p>
              </div>
              <div className="torchbearer">
                <img src={kmm} alt="K. M. Mathew" className="small-icon" />
                <p className="torchbearer-name">K. M. Mathew</p>
                <p className="torchbearer-name">First member </p>
              </div>
            </div>
          </div>
        </div>
      </div>




      <div id="milestones"><Milestones /></div>
      <div id="leadership"><Leadership /></div>
      <div id="eventgallery"><EventsGallery /></div>
      <div id="events"><Events /></div>
      <div id="gallery"><Gallery /></div>
      <div id="about"><AboutUs /></div>
      <div id="contact"><Contact /></div>

      {showPopup && (
        <div className="popup">
          <div className="popup-overlay">
            <div className="popup-content">
              <div className="popup-header">
                <h3>Join Us</h3>
                <img src={logo} alt="Logo" className="popup-logo" />
              </div>

              <label>Name:</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />

              <label>Date of Birth:</label>
              <input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} required />
              {ageError && <p className="error-message">{ageError}</p>}

              <label>Address:</label>
              <textarea name="address" value={formData.address} onChange={handleChange} required></textarea>

              <label>District:</label>
              <select name="district" value={formData.district} onChange={handleChange} required>
                <option value="">Select District</option>
                {districts.map((district, index) => (
                  <option key={index} value={district}>{district}</option>
                ))}
              </select>

              <label>Place:</label>
              <input type="text" name="place" value={formData.place} onChange={handleChange} required />

              <label>Phone:</label>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} required />
              {phoneError && <p className="error-message">{phoneError}</p>}

              <div className="form-group">
                <label>
                  <input type="checkbox" name="agreement" checked={formData.agreement || false} onChange={handleChange} required />
                  I agree to the collection and use of my data.
                </label>
              </div>

              <div className="button-group">
                <button className="ok-button" onClick={handleSubmit}>Submit</button>
                <button className="cancel-button" onClick={() => setShowPopup(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSuccess && (
        <div className="success-modal">
          <div className="success-content">
            <p>Successfully Registered!</p>
            <button className="ok-button" onClick={() => setShowSuccess(false)}>OK</button>
          </div>
        </div>
      )}

      {showFailure && (
        <div className="success-modal">
          <div className="success-content">
            <p>Registration Failed!</p>
            <button className="cancel-button" onClick={() => setShowFailure(false)}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
